import { useFormContext } from 'react-hook-form';
import { cn } from '@/utils';
import { VEHICLE_CATEGORY_OPTIONS, type MotorQuoteFormData } from '../../schema';

export function VehicleTypeStep() {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<MotorQuoteFormData>();

  const vehicleCategory = watch('vehicle_category');

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Vehicle Type</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        What kind of vehicle is this quote for?
      </p>

      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Vehicle Type
        <span className="text-red-500 ml-1">*</span>
      </label>
      <div className="flex flex-wrap gap-2">
        {VEHICLE_CATEGORY_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => {
              setValue('vehicle_category', option.value, {
                shouldValidate: true,
                shouldDirty: true,
              });
              // Make/Model/Variant are filtered by vehicle category — a prior
              // selection may no longer be a valid option under the new one,
              // so the whole cascade is reset rather than left stale.
              if (option.value !== vehicleCategory) {
                setValue('make_id', '', { shouldValidate: false });
                setValue('make_name', '', { shouldValidate: false });
                setValue('model_id', '', { shouldValidate: false });
                setValue('model_name', '', { shouldValidate: false });
                setValue('variant_id', '', { shouldValidate: false });
                setValue('variant_name', '', { shouldValidate: false });
                setValue('fuel_type', '', { shouldValidate: false });
              }
            }}
            className={cn(
              'px-4 py-2 rounded-lg text-sm font-medium transition-colors border',
              vehicleCategory === option.value
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
      {errors.vehicle_category && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-400">{errors.vehicle_category.message}</p>
      )}
    </div>
  );
}
